module.exports = "/_next/static/images/7300817a67c8ad27af0f608715e22fe8-mgm-750.jpg.webp";